import { images } from '../constants';

const activities = [
    {
        id: 1,
        image: images.activity1,
        title: 'Hiking',
        paragraphs: [
            "Explore breathtaking trails, serene landscapes, and connect with nature through our guided hiking adventures. Whether you're a beginner or seasoned trekker, we offer routes tailored to every skill level.",
            "Experience the thrill of the outdoors, learn about local flora and fauna, and create unforgettable memories on safe and well-organized hikes led by experienced guides."
        ],
        gallery: [
            images.activity1Gallery1,
            images.activity1Gallery2
        ],
        highlights: [
            'Scenic nature trails and mountain views',
            'Experienced and certified hiking guides',
            'Group and solo hiking options',
            'Eco-friendly and sustainable practices',
            'All fitness levels welcome'
        ],
        requirements: [
            'Basic physical fitness and mobility',
            'Comfortable hiking shoes or boots',
            'Weather-appropriate clothing and water',
            'Signed liability waiver before hike',
            'Follow safety instructions and trail rules'
        ],
    },
    {
        id: 2,
        image: images.activity2,
        title: 'Camping',
        paragraphs: [
            'Escape the hustle and bustle of everyday life with our immersive camping experiences. Settle under starry skies, enjoy the calm of nature, and unwind around a cozy campfire.',
            'Our well-equipped camping spots offer a safe, enjoyable environment perfect for families, solo travelers, or groups looking to reconnect with nature.'
        ],
        gallery: [
            images.activity2Gallery1,
            images.activity2Gallery2
        ],
        highlights: [
            'Scenic and safe campgrounds',
            'Campfire and stargazing sessions',
            'Tent and gear provided (optional)',
            'Nature walks and wildlife spotting',
            'Family-friendly activities and games'
        ],
        requirements: [
            'Carry essentials like sleeping bag and warm clothing',
            'Follow campsite rules and guidelines',
            'Respect nature and maintain cleanliness',
            'Be prepared for weather changes',
            'Basic first-aid knowledge is a plus'
        ],
    },
    {
        id: 3,
        image: images.activity3,
        title: 'Rock Climbing',
        paragraphs: [
            "Challenge yourself physically and mentally with our guided rock climbing adventures. Whether you're a beginner or an experienced climber, our routes cater to all skill levels.",
            "With expert instructors, safety gear, and breathtaking vertical views, rock climbing offers an unforgettable outdoor thrill."
        ],
        gallery: [
            images.activity3Gallery1,
            images.activity3Gallery2
        ],
        highlights: [
            'Guided climbs for all skill levels',
            'Top-notch safety equipment included',
            'Training sessions for beginners',
            'Scenic climbing locations',
            'Build strength, focus, and endurance'
        ],
        requirements: [
            'Basic physical fitness and flexibility',
            'Wear comfortable climbing attire',
            'Follow safety instructions strictly',
            'Use of climbing helmet and harness',
            'Listen to guide’s briefing before the climb'
        ],
    },
    {
        id: 4,
        image: images.activity4,
        title: 'Wildlife Viewing',
        paragraphs: [
            "Immerse yourself in nature and observe wildlife in their natural habitats. Our guided wildlife viewing tours offer a peaceful, educational, and awe-inspiring experience.",
            "With the help of expert naturalists, you'll gain insights into animal behavior and ecosystems while exploring pristine landscapes."
        ],
        gallery: [
            images.activity4Gallery1,
            images.activity4Gallery2
        ],
        highlights: [
            'Guided tours with expert naturalists',
            'Opportunity to spot rare and native species',
            'Scenic routes through forests and reserves',
            'Photography-friendly environments',
            'Eco-conscious and respectful of wildlife'
        ],
        requirements: [
            'Binoculars or camera recommended',
            'Wear neutral-colored clothing',
            'Follow silent observation guidelines',
            'Stay on marked trails and paths',
            'Respect wildlife from a distance'
        ],
    },
    {
        id: 5,
        image: images.activity5,
        title: 'Trail Running',
        paragraphs: [
            'Experience the thrill of running through nature on rugged trails, surrounded by scenic landscapes and fresh air. Trail running is perfect for those who enjoy an active lifestyle with an adventurous twist.',
            'Our trails vary in difficulty and length, making them suitable for both beginners and seasoned runners looking to challenge themselves off-road.'
        ],
        gallery: [
            images.activity5Gallery1,
            images.activity5Gallery2
        ],
        highlights: [
            'Challenging and scenic running trails',
            'Improves endurance and mental clarity',
            'Runs led by experienced trail guides',
            'Routes for all skill levels',
            'Fresh air and natural terrain for better cardio'
        ],
        requirements: [
            'Wear proper trail running shoes',
            'Carry water and energy snacks',
            'Check weather and trail conditions',
            'Warm-up and stretch before starting',
            'Respect trail etiquette and natural surroundings'
        ],
    },
    {
        id: 6,
        image: images.activity6,
        title: 'Fishing',
        paragraphs: [
            'Enjoy a relaxing day by the water with our fishing experiences. Whether you’re a seasoned angler or a beginner, we provide tranquil settings and all the necessary gear for a successful fishing trip.',
            'Our fishing spots are carefully selected to ensure a great catch, with a variety of freshwater and saltwater options available.'
        ],
        gallery: [
            images.activity6Gallery1,
            images.activity6Gallery2
        ],
        highlights: [
            'Guided fishing trips with expert anglers',
            'Variety of fishing locations (freshwater & saltwater)',
            'All necessary fishing equipment provided',
            'Catch and release or keep your fish (based on regulations)',
            'Ideal for solo anglers or family groups'
        ],
        requirements: [
            'Bring comfortable clothing and sun protection',
            'Bring snacks, drinks, and a hat for sun protection',
            'Check local fishing regulations (catch limits, licenses)',
            'No previous fishing experience required',
            'Stay hydrated and follow safety instructions'
        ],
    },

];

export default activities;